export default __webpack_public_path__ + "static/media/net-icon.b571044f.webp";